import config from '~/config';
import Price from '~/utils/Price/Price';

import PriceOrigin from './PriceOrigin';

export enum PriceType {
	exFactory = 'ex-factory',
}

export default class ProductPrice {
	public readonly origin: PriceOrigin | null;

	public readonly price: Price | null;

	public readonly priority: number;

	public readonly type: string;

	public constructor(type: string, price: Price | null, priority: number, origin: PriceOrigin | null = null) {
		this.type = type;
		this.price = price;
		this.priority = priority;
		this.origin = origin;
	}

	public humanCondensedFormatType(): string {
		const type = config.product.priceTypes.find((type) => type.code === this.type);
		return type !== undefined ? type.condensedLabel : this.type;
	}

	public humanFormatType(): string {
		const type = config.product.priceTypes.find((type) => type.code === this.type);
		return type !== undefined ? type.label : this.type;
	}

	public isExFactory(): boolean {
		return this.type === PriceType.exFactory;
	}
}
